import React from 'react';
import style from './consulting.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ConsultingLanding(props) {

  //Set the window size state to maintain media queries
  const [gridSize, setGridSize] = useState(0)
  
  useEffect (() => {
		const handleGridResize = () => {
      let limit = 0
			if (props.windowSize === "Web") {
        //set column limit
        limit = 3
      } else if (props.windowSize === "Tablet") {
          //set column limit
          limit = 3
      } else {
        //set column limit
        limit = 3
      }

			if (limit !== gridSize) {
				setGridSize(limit)
			}
		}
		
		window.addEventListener('resize', handleGridResize)

		handleGridResize()

		return () => {
			window.removeEventListener('resize', handleGridResize)
		}
  }) 

  let mainPath = '/e2-engineering-services/consulting-services/'
  let linkArr = [
    'System Evaluation and Enhancement Studies',
    'Regulatory Compliance',
    'Arc Flash Hazard Evaluation',
  ]

  //Handles css grid layout for IE
  let linkElements = []
  let colCount = 1
  let rowCount = 1
  let linkCount = 0

  for (let i = 0; i < linkArr.length; i++) {
    if (props.windowSize !== "Mobile") {
      let classStr = ``

      //Add a right border to every cell that is not the last column in a row
      if (((linkCount + 1) % gridSize) !== 0) {
        classStr += ` ${style.borderRight}`
      }

      //Add a bottom border to every cell that is not in the last row
      if (rowCount < ((Math.floor(linkArr.length / gridSize) + 1) - 1)) {
        classStr += ` ${style.borderBottom}`
      } 

      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a className={classStr} style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    } else {
      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    }  

    //Check if column gridSize has been reached
    if (colCount === gridSize) {
      colCount = 1
      rowCount++
    } else {
      colCount++
    }

    linkCount++
  }

  //Handles style grid by creating the circle elements and changing the columns/rows accordingly (Tablet and Web only)
  let circles = null
  let styleBox1 = null
  let styleBox2 = null
  let styleGrid = null
  let limit = 0

  if (props.windowSize !== "Mobile") {
    limit = 13
    colCount = 1
    rowCount = 1
    circles = []

    for (let x = 0; x < (7 * 13); x++) {

      //Creating accent circle
      circles[x] = <span key={"span" + x} style={{msGridRow: rowCount, msGridColumn: colCount}}></span>

      if (colCount === limit) {
        colCount = 1
        rowCount++
      } else {
        colCount++
      }
    }

    styleBox1 = <div className={style.styleBoxOne}></div>
    styleBox2 = <div className={style.styleBoxTwo}></div>
    styleGrid = <div className={style.styleGrid}>{circles}</div>
  }

  return (
    <div className={style.ConsultingLanding}>
      <Head>
        <title>Consulting Services | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> E&#178; Engineering Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>Consulting Services</h3>
      <div className={style.quickLinkContainer}>
        {styleBox1}
        {styleBox2}
        {styleGrid}  
        <div className={style.quickLinks}>
          {linkElements}
        </div>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[0]}</h4>
        <p>Today, power supply is of utmost concern. Increases in demand continue to burden power suppliers, emphasizing the critical importance of maximum efficiency and reliability. While focusing on processes (Life Management Programs) to extend the life expectancy of turbines and generators, consideration must be given to the excitation control systems to ensure that the demands of voltage support throughout the system are being met.</p>
        <Link href={mainPath + linkArr[0].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[1]}</h4>
        <p>Reliability is the primary concern. To be able to predict the overall system response and reliability, NERC needs to know the capabilities of the generating systems and the anticipated performance for both steady state operation and during system transients caused by loss of generation, faults or other types of disturbances.</p>
        <Link href={mainPath + linkArr[1].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[2]}</h4>
        <p>Arc flash hazard is the dangerous condition associated with the release of energy caused by an electric arc. Electric arcs produce intense heat, sound blast and pressure waves. Arc flash causes extremely high temperatures, and can radiate intense heat, igniting clothing and causing severe burns that can be fatal. Therefore, it is essential to have an accurate study when working on energized equipment.</p>
        <Link href={mainPath + linkArr[2].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
    </div>
  );
}

export default ConsultingLanding;